import request from "../../utils/request";

export const select = params => {
    return request({
        url: "/api/blade-platform/platformCarouselImgManage/getCarouselImgList",
        method: "post",
        data: params
    });
};

export const add = params => {
    return request({
        url:
            "/api/blade-platform/platformCarouselImgManage/saveOrUpdatePlatformCarouselImg",
        method: "post",
        data: params
    });
};

export const delect = params => {
    return request({
        url: "/api/blade-platform/platformCarouselImgManage/deleteImgByIds",
        method: "post",
        data: params
    });
};

export const openClose = params => {
    return request({
        url:
            "/api/blade-platform/platformCarouselImgManage/updateImgStatusByIds",
        method: "post",
        data: params
    });
};

export const upicon = params => {
    return request({
        url: "/api/blade-platform/file/upload",
        method: "post",
        data: params,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
